import React, { type ReactElement } from 'react';
import { JsonParam, useQueryParam } from 'use-query-params';
import CategoryReport from 'feature-components/reports/category-report';
import { useManageReportDocumentTitle } from 'hooks/useDocumentTitle';
import ClusterReportLayout from 'pages/clusters/layouts/cluster-report-layout';
import type { Filters, FormValues } from 'pages/clusters/types';

type Props = { identifier: string } & Omit<
  Parameters<typeof CategoryReport>[0],
  'isReferenceDataVisible'
>;

export default function ClusterCategoryReport(props: Props): ReactElement {
  const { identifier, ...reportProps } = props;

  const [entryFilters] = useQueryParam<FormValues>('entry', JsonParam);
  const [filters, setFilters] = useQueryParam<Filters | undefined>('filters', JsonParam, {
    updateType: 'replaceIn'
  });

  useManageReportDocumentTitle(identifier);

  return (
    <ClusterReportLayout.Report>
      <CategoryReport {...reportProps} isReferenceDataVisible={!filters?.isReferenceDataHidden} />
      <ClusterReportLayout.Sidebar>
        <ClusterReportLayout.Sidebar.CommonFilters
          filters={filters}
          entryFilters={entryFilters}
          onChange={setFilters}
        />
      </ClusterReportLayout.Sidebar>
    </ClusterReportLayout.Report>
  );
}
